import React from "react";

const STATS = [
  { v: "₹3.5L", l: "Avg cost of one bad hire" },
  { v: "48 hrs", l: "Median time-to-first-interview on Wishire" },
  { v: "5 ×", l: "Tools replaced with one stack" },
  { v: "100 %", l: "Companies verified before they post" },
];

const QUOTES = [
  {
    name: "Aanya Mehta",
    role: "Head of Talent, FinTrust",
    avatar: "https://images.pexels.com/photos/7580644/pexels-photo-7580644.jpeg",
    body:
      "We replaced our ATS, two job boards and a screening vendor. Hiring managers actually use it.",
  },
  {
    name: "Rohan Kapoor",
    role: "Senior Product Manager (placed via Wishire)",
    avatar: "https://images.pexels.com/photos/7644081/pexels-photo-7644081.jpeg",
    body:
      "I knew where I stood for the first time. The voice interview reps are unfair — in the best way.",
  },
  {
    name: "Priya Iyer",
    role: "Founder, Lumen Studios (12-person team)",
    avatar: "https://images.pexels.com/photos/7255432/pexels-photo-7255432.jpeg",
    body:
      "Our last engineering hire took 9 days, end to end. We talked to four candidates. All four were excellent.",
  },
];

const LOGOS = [
  "Lumen", "FinTrust", "Hyperloom", "North & Co", "Studio Saffron",
  "Briefcase Labs", "Indigo Works", "Foundry 27",
];

export default function Trust() {
  return (
    <section className="section">
      <div className="container-x">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-stone-300 border border-stone-300 rounded-3xl overflow-hidden">
          {STATS.map((s) => (
            <div key={s.l} className="bg-[#FDFBF7] p-8 text-center">
              <p className="font-display text-4xl md:text-5xl text-stone-900">
                {s.v}
              </p>
              <p className="overline mt-3">{s.l}</p>
            </div>
          ))}
        </div>

        {/* Logo marquee */}
        <div className="mt-16 wsh-no-scrollbar overflow-hidden border-y border-stone-200 py-8">
          <div className="wsh-marquee-track">
            {[...LOGOS, ...LOGOS].map((l, i) => (
              <span
                key={i}
                className="font-display text-2xl md:text-3xl text-stone-400 italic"
              >
                {l}
              </span>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
          {QUOTES.map((q) => (
            <figure
              key={q.name}
              className="rounded-3xl border border-stone-200 bg-white p-8 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(28,25,23,0.25)] transition-all duration-300 reveal"
            >
              <blockquote className="font-display text-xl leading-snug text-stone-900">
                &ldquo;{q.body}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={q.avatar}
                  alt={q.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-stone-900 text-sm font-medium">{q.name}</p>
                  <p className="text-stone-500 text-xs">{q.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
